<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content fluid fill-height>
      <HeaderSimple />
      <v-stepper v-model="e1" class="elevation-0">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :complete="e1 > 1" step="1">Informações de Login</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2"> Dados Pessoais </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form v-model="valid" ref="form">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-5">
                        <v-text-field
                          solo
                          flat
                          label="Nome Completo"
                          v-model="name"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Email"
                          v-model="email"
                          :rules="emailRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-checkbox
                        v-model="checkbox"
                        required
                        :rules="[
                          (v) =>
                            !!v ||
                            'Você deve aceitar os Termos de Uso e Política de Privacidade para continuar.',
                        ]"
                      >
                        <template v-slot:label>
                          <div>
                            Li e aceito os
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a target="_blank" href="/termo" @click.stop v-on="on"
                                  >Termos de Uso</a
                                >
                              </template>
                              {{ $t('pageCadastro.tooltipAba') }} </v-tooltip
                            >e a
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a target="_blank" href="/privacidade" @click.stop v-on="on"
                                  >Política de Privacidade</a
                                >
                              </template>
                              {{ $t('pageCadastro.tooltipAba') }}
                            </v-tooltip>
                          </div>
                        </template>
                      </v-checkbox>
                      <v-btn
                        color="secondary"
                        depressed
                        large
                        @click="verifyEmail"
                        :disabled="!valid"
                        >CONTINUAR</v-btn
                      >
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form v-model="valid2" ref="form2">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelPassword')"
                          v-model="password"
                          :append-icon="show1 ? 'visibility' : 'visibility_off'"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                          :rules="passwordRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelConfirmPassword')"
                          v-model="check_password"
                          :append-icon="show2 ? 'visibility' : 'visibility_off'"
                          :type="show2 ? 'text' : 'password'"
                          @click:append="show2 = !show2"
                          :rules="senhaConfirmationRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-select
                          :items="list_gender"
                          label="Sexo"
                          @change="getGender"
                          :rules="rules"
                          required
                          solo
                          flat
                          background-color="#F7F7F7"
                        ></v-select>
                        <DatePicker v-on:date="saveDate" />
                        <v-row class="mt-6" no-gutters>
                          <v-col class="col-4 pr-2">
                            <CountryCodeSelect
                              v-model="phoneCountry"
                              :countries="allPhoneCountries"
                            />
                          </v-col>
                          <v-col class="col-8">
                            <v-text-field
                              :key="phoneCountry"
                              solo
                              flat
                              label="Número de Telefone"
                              :value="tel"
                              @input="onPhoneInput"
                              :rules="phoneRules"
                              type="tel"
                              required
                              background-color="#F7F7F7"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        color="secondary"
                        depressed
                        large
                        @click="submit"
                        :disabled="!valid2"
                        :loading="loader"
                        >FINALIZAR</v-btn
                      >
                      <v-btn text to="login">Cancelar</v-btn>
                    </v-row>
                    <v-row class="align-center justify-center">
                      <v-col class="col-10 col-md-8">
                        <v-alert v-model="isMenor" type="warning" dismissible>
                          Você necessita enviar a autorização de um responsável. Envie para
                          geral@ondivan.net o nome, idade e documento do seu responsável, junto com
                          a autorização para a realização das consultas. Caso não envie, não poderá
                          realizar consultas no Ondivan.
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-content>
  </v-app>
</template>

<script>
import HeaderSimple from '@/components/HeaderSimple';
import DatePicker from '@/components/DatePicker';
import CountryCodeSelect from '@/components/CountryCodeSelect';
import ct from 'countries-and-timezones';
import { AsYouType, isValidPhoneNumber, getCountryCallingCode } from 'libphonenumber-js';
import Api from '../../services/httpClient';
import i18n from '../../plugins/i18n';
import getLanguage from '../../utils/getLanguage';
import { getAllPhoneCountries, getDefaultPhoneCountry } from '../../utils/phoneCountriesFull';

export default {
  components: {
    HeaderSimple,
    DatePicker,
    CountryCodeSelect,
  },
  data: () => ({
    valid: false,
    valid2: false,
    show1: false,
    show2: false,
    loader: false,
    e1: 1,
    name: '',
    list_gender: ['Masculino', 'Feminino', 'Outros'],
    gender: '',
    language: '',
    phoneCountry: 'BR',
    allPhoneCountries: getAllPhoneCountries(),
    date_birth: '',
    tel: '',
    time_offset: '',
    time_zone_name: '',
    email: '',
    check_email: '',
    password: '',
    check_password: '',
    checkbox: false,
    rules: [(v) => !!v || 'Esse campo é obrigatório'],
    emailRules: [
      (v) => !!v || 'Email é obrigatório',
      (v) => /^\s*\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})\s*/.test(v) || 'Email está invalido',
    ],
    passwordRules: [
      (v) => !!v || 'A senha é obrigatória',
      (v) =>
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v) ||
        'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
    ],
    snackbar: false,
    msg: '',
    isMenor: false,
  }),

  computed: {
    phoneRules() {
      return [
        (v) => !!v || 'Esse campo é obrigatório',
        (v) => isValidPhoneNumber(v || '', this.phoneCountry) || 'Número de telefone inválido',
      ];
    },

    emailConfirmationRules() {
      return [
        (v) => !!v || 'Email é obrigatório',
        () =>
          this.email === this.check_email || 'Email não corresponde com o informado anteriormente.',
        (v) => /^\s*\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})\s*/.test(v) || 'Email está invalido',
      ];
    },

    senhaConfirmationRules() {
      return [
        (v) => !!v || 'A senha é obrigatória',
        () =>
          this.password === this.check_password ||
          'A Senha não corresponde com a informada anteriormente.',
        (v) =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v) ||
          'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
      ];
    },
  },
  async created() {
    this.language = await getLanguage(window.location.href);
    this.phoneCountry = getDefaultPhoneCountry(this.language);
    this.setTimezone();
  },

  watch: {
    language(val) {
      i18n.locale = val;
    },
    phoneCountry() {
      this.tel = '';
    },
  },

  methods: {
    setTimezone() {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const countryTimezone = ct.getTimezone(timezone);
      if (countryTimezone) {
        this.time_offset = countryTimezone.utcOffsetStr;
        this.time_zone_name = timezone;
      }
    },
    createLead() {
      Api.post('/leads/', {
        name: this.name,
        email: this.email.trim(),
        language: this.language,
        user_type: 'patient',
      }).catch(() => {});
    },

    verifyEmail() {
      this.createLead();
      Api.post('/users/check_username/', {
        username: this.email.trim(),
      })
        .then((response) => {
          console.log(response.data);
          // this.e1 = 2;
          this.msg = response.data;
          this.snackbar = true;
        })
        .catch((err) => {
          console.log(err.response.data.detail);
          this.e1 = 2;
        });
    },

    getGender(v) {
      this.gender = v;
    },

    onPhoneInput(value) {
      const digits = value.replace(/\D/g, '');
      this.tel = new AsYouType(this.phoneCountry).input(digits);
    },

    async submit() {
      if (this.$refs.form2.validate()) {
        this.loader = true;
        await this.signUp();
      }
    },
    /**
     * Função que envia todos os dados do paciente para fazer o cadastro dele no sistema.
     */
    async signUp() {
      try {
        const { data } = await Api.post('/patients/', {
          name: this.name,
          language: this.language,
          gender: this.gender,
          date_birth: this.date_birth,
          telephone: `+${getCountryCallingCode(this.phoneCountry)} ${this.tel}`,
          time_zone: this.time_offset,
          time_zone_name: this.time_zone_name,
          email: this.email.trim(),
          password: this.password,
          confirm_password: this.check_password,
        });
        this.autoLogin(data);
      } catch (err) {
        console.log(err.response.data);
        if (err.response.data.email) {
          this.snackbar = true;
          this.msg = err.response.data.email;
        }
        this.loader = false;
      }
    },

    /**
     * Loga o paciente automaticamente usando o token já retornado pelo próprio
     * endpoint de cadastro (/patients/), evitando uma segunda chamada de login
     * e a checagem de idioma feita pelo /api-token-auth/.
     */
    autoLogin(patientData) {
      const userData = { ...patientData };
      delete userData.token;
      localStorage.setItem('user-token', patientData.token);
      localStorage.setItem('user-id', patientData.id);
      localStorage.setItem('user-category', 'patient');
      localStorage.setItem('user-data', JSON.stringify(userData));
      this.loader = false;
      this.$router.replace('/paciente');
    },

    gettanggal(str) {
      if (str != null) {
        return `${str.substring(8, 10)}/${str.substring(5, 7)}/${str.substring(0, 4)}`;
      }
      return '';
    },

    saveDate(value) {
      const dateNow = new Date();
      const baseYear = dateNow.getFullYear() - 18;
      const userYear = value.slice(0, 4);
      if (userYear > baseYear) {
        // verifica se o ano quer usuario escolheu é maior que o ano base
        this.isMenor = true;
      } else if (baseYear == userYear) {
        if (value.slice(5, 7) > dateNow.getMonth()) {
          this.isMenor = true;
        } else if (value.slice(5, 7) == dateNow.getMonth()) {
          if (value.slice(9, 10) < dateNow.getDate()) {
            this.isMenor = true;
          }
        }
      }
      this.date_birth = value;
    },
  },
};
</script>
